import { render, staticRenderFns } from "./FormNewDocumentationDescriptionApi.vue?vue&type=template&id=b653dd8e"
import script from "./FormNewDocumentationDescriptionApi.vue?vue&type=script&lang=js"
export * from "./FormNewDocumentationDescriptionApi.vue?vue&type=script&lang=js"
import style0 from "./FormNewDocumentationDescriptionApi.vue?vue&type=style&index=0&id=b653dd8e&lang=scss"
import style1 from "./FormNewDocumentationDescriptionApi.vue?vue&type=style&index=1&id=b653dd8e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b653dd8e')) {
      api.createRecord('b653dd8e', component.options)
    } else {
      api.reload('b653dd8e', component.options)
    }
    module.hot.accept("./FormNewDocumentationDescriptionApi.vue?vue&type=template&id=b653dd8e", function () {
      api.rerender('b653dd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewServiceForm/components/FormNewDocumentationDescriptionApi.vue"
export default component.exports